import { createRoot } from 'react-dom/client';
import { LocaldataProvider } from 'react-localdata';
import { BrowserRouter } from 'react-router-dom';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';

import { UserProvider } from 'app/common/UserContext';
import AppErrorBoundary from 'app/common/ErrorBoundary/AppErrorBoundary';
import { getDefaultLocaldata } from 'app/utils/localdata';

import { initSentry } from './utils/sentry';
import App from './App';

import './style.scss';

polyfillCountryFlagEmojis();
// Init Sentry service for bug tracking
initSentry();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <AppErrorBoundary>
    <BrowserRouter>
      <UserProvider>
        <LocaldataProvider defaultData={getDefaultLocaldata()}>
          <App />
        </LocaldataProvider>
      </UserProvider>
    </BrowserRouter>
  </AppErrorBoundary>
);
